import NotFoundScreen from "./NotFoundScreen";

export default NotFoundScreen;
